// Extract window.location.origin access to a separate function
export const getCurrentOrigin = (): string => {
    return window.location.origin.toLowerCase();
};
